import React, { useMemo } from 'react';

import { FolderNavigationType } from '../types';
import FolderFormModal from './FolderFormModal';
import { EditFolderModalProps } from './types';

const getDescendantIds = (folder: FolderNavigationType): Set<string> => {
  const ids = new Set<string>([folder.uuid]);
  folder.subfolders.forEach((subfolder) => {
    getDescendantIds(subfolder).forEach((id) => ids.add(id));
  });
  return ids;
};

const EditFolderModal: React.FC<EditFolderModalProps> = ({
  open,
  folder,
  onClose,
  onSave,
  folders,
  loading = false,
}) => {
  const excludedFolderIds = useMemo(() => getDescendantIds(folder), [folder]);

  return (
    <FolderFormModal
      open={open}
      title="Edit Folder"
      submitButtonText="Save changes"
      initialName={folder.name}
      initialParent={folder.parent?.uuid}
      excludedFolderIds={excludedFolderIds}
      folders={folders}
      loading={loading}
      onClose={onClose}
      onSubmit={onSave}
    />
  );
};

export default EditFolderModal;
